import React, { Component } from "react";
import withServices from "src/HOCs/withServices";
import Loader from "react-loader";
import { Redirect } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import {
  ssoLogin,
  currentBaseUrl,
  isFirstLogIn,
  isUserLoggedIn,
  isBasicPreassessmentDone,
  currentUser,
  currentProfile,
  currentDesignation,
  currentSubscriptionLevel,
  hasActiveSubscription,
  isUserUpgraded,
} from "../../common/services";

import NavBar from "../../components/CustomNav/CustomNav.Component";
import { Container, ResetForm } from "./veryTokenPage.css";

interface Props {
  services: any;
  history: any;
  location: any;
}

interface IState {
  token: string;
  baseurl: string;
  tokenStatus: string;
  toLogin: boolean;
  loaded: boolean;
  newPassword: string;
  resetLoaded: boolean;
  resetSuccess: boolean;
  toAdminDash: boolean;
  toSchoolDash: boolean;
  toTeacherDash: boolean;
  toTeacherPreassessment: boolean;
  toParentOnboarding: boolean;
  toPreassessment: boolean;
  toParentAssessment: boolean;
  toDashboard: boolean;
}

class VerifyTokenPage extends Component<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      baseurl: currentBaseUrl(),
      token: "",
      tokenStatus: "",
      toAdminDash: false,
      toLogin: false,
      loaded: false,
      newPassword: "",
      resetLoaded: false,
      resetSuccess: false,
      toSchoolDash: false,
      toTeacherDash: false,
      toTeacherPreassessment: false,
      toParentOnboarding: false,
      toPreassessment: false,
      toParentAssessment: false,
      toDashboard: false,
    };
  }

  public async componentDidMount() {
    const token: any = new URLSearchParams(this.props.location.search).get(
      "token"
    );
    if (token === null) {
      toast.error("Invalid Link, try again");
      setTimeout(() => {
        this.setState({ toLogin: true });
      }, 5000);
    }

    ssoLogin({ token }, (text) => this.handleLogin(text));
  }

  public handleLogin(res) {
    if (res.code === 200) {
      this.setState({ loaded: true });
      this.setState({ baseurl: currentBaseUrl() });

      if (currentDesignation() === "schools") {
        if (isUserUpgraded()) {
          this.setState({ toSchoolDash: true });
        } else {
          this.props.history.replace("/schools/purchase");
        }
      } else if (currentDesignation() === "teachers") {
        if (isBasicPreassessmentDone()) {
          this.setState({ toTeacherDash: true });
        } else {
          this.setState({ toTeacherDash: true });
        }
      }

      if (
        isFirstLogIn() &&
        currentBaseUrl() !== "schools" &&
        currentBaseUrl() !== "admins"
      ) {
        if (currentDesignation() === "parents") {
          this.setState({ toParentOnboarding: true });
        }
        if (currentDesignation() === "students") {
          this.setState({ toPreassessment: true });
        }
      } else if (!isFirstLogIn() && !isBasicPreassessmentDone()) {
        if (currentDesignation() === "parents") {
          this.setState({ toParentAssessment: true });
        }
        if (currentDesignation() === "students") {
          this.setState({ toPreassessment: true });
        }
      }
      // else if (isFirstLogIn() && !isBasicPreassessmentDone()) {
      //   // console.log(currentUser() + " profile details " + JSON.stringify(currentProfile(), null, 4));
      //   // this.setState({toPreassessment: true});
      //   if (currentDesignation() === "parents") {
      //     this.setState({ toParentAssessment: true });
      //   }
      //   if (currentDesignation() === "students") {
      //     this.setState({ toPreassessment: true });
      //   }
      // }
      else if (!isFirstLogIn() && isBasicPreassessmentDone()) {
        // if (currentDesignation() === "parents") {
        this.setState({ toDashboard: true });
        // }
      } else if (isBasicPreassessmentDone()) {
        this.setState({ toDashboard: true });
      }

      if (hasActiveSubscription() && isUserUpgraded()) {
        this.setState({ toDashboard: true });
      }
    } else if (res.code === 404) {
      alert("failed");
      this.setState({ loaded: true });
      toast.error("Login failed, check username or password");
    }
  }

  public render() {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }
    if (this.state.toDashboard === true) {
      return <Redirect to={this.state.baseurl + "home"} />;
    }
    if (this.state.toParentOnboarding === true) {
      return <Redirect to={this.state.baseurl + "purchase"} />;
    }
    if (this.state.toPreassessment) {
      return <Redirect to={this.state.baseurl + "preassessmentguide"} />;
    }
    if (this.state.toTeacherPreassessment) {
      return <Redirect to={this.state.baseurl + "assessment"} />;
    }
    if (this.state.toParentAssessment) {
      return <Redirect to={this.state.baseurl + "assessmentguide"} />;
    }
    if (this.state.toAdminDash) {
      return <Redirect to={`${this.state.baseurl}home`} />;
    }
    if (this.state.toSchoolDash) {
      return <Redirect to={`${currentBaseUrl()}menu`} />;
    }
    if (this.state.toTeacherDash) {
      return <Redirect to={`${currentBaseUrl()}menu`} />;
    }
    return (
      <div style={{ height: "100vh", width: "100vw" }}>
        <ToastContainer />
        <NavBar />
        <Loader loaded={this.state.loaded}>
          <p>Loading</p>
        </Loader>
      </div>
    );
  }
}

export default withServices(VerifyTokenPage);



// WEBPACK FOOTER //
// ./src/pages/SSO/veryTokenPage.Component.tsx